import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a20678e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "calculation-result"
}
const _hoisted_2 = { class: "calculation-result__table" }
const _hoisted_3 = { class: "calculation-result__table-head" }
const _hoisted_4 = { class: "calculation-result__table-line" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "calculation-result__table-head-cell" }, null, -1))
const _hoisted_6 = { class: "calculation-result__table-head-cell" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "calculation-result__table-head-cell" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "calculation-result__table-head-cell" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "2", -1))
const _hoisted_13 = { class: "calculation-result__table-body" }
const _hoisted_14 = { class: "calculation-result__table-line" }
const _hoisted_15 = { class: "calculation-result__table-line-cell calculation-result__table-line-cell--head" }
const _hoisted_16 = { class: "calculation-result__table-line-cell" }
const _hoisted_17 = { class: "calculation-result__table-line-cell" }
const _hoisted_18 = { class: "calculation-result__table-line-cell" }
const _hoisted_19 = { class: "calculation-result__table-line" }
const _hoisted_20 = { class: "calculation-result__table-line-cell calculation-result__table-line-cell--head" }
const _hoisted_21 = { class: "calculation-result__table-line-cell" }
const _hoisted_22 = { class: "calculation-result__table-line-cell" }
const _hoisted_23 = { class: "calculation-result__table-line-cell" }
const _hoisted_24 = { class: "calculation-result__table-line" }
const _hoisted_25 = { class: "calculation-result__table-line-cell calculation-result__table-line-cell--head" }
const _hoisted_26 = { class: "calculation-result__table-line-cell" }
const _hoisted_27 = { class: "calculation-result__table-line-cell" }
const _hoisted_28 = { class: "calculation-result__table-line-cell" }

import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { IonCard, IonText } from '@ionic/vue';
import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';
import { Dialog } from '@capacitor/dialog';
import { useComputeWizardStore } from '@/store/computeWizard';
import usePhoneGallery from '@/composables/usePhoneGallery';
import useLoader from '@/composables/useLoader';
import { Platform } from '@/enums/Platform';
import { Icons } from '@/enums/Icons';
import BaseButton from '@/components/BaseButton.vue';
import BaseIcon from '@/components/BaseIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalculationResult',
  setup(__props) {

const { t } = useI18n();
const { saveScreenshot } = usePhoneGallery();
const { showLoader, hideLoader } = useLoader();

const computeWizardStore = useComputeWizardStore();

const isMobile = ref(Capacitor.getPlatform() === Platform.IOS || Capacitor.getPlatform() === Platform.ANDROID);

const washerHardnessLabel = computed(() => {
  return t('result.washer_hardness', { value: computeWizardStore?.computedValues?.washerHardness });
});

const onScreenShotButtonClick = async () => {
  await showLoader(t('screenshot.loading'));

  try {
    const pictureUri = await saveScreenshot();

    await hideLoader();

    const { value } = await Dialog.confirm({
      title: t('screenshot.success_title'),
      message: t('screenshot.success_message'),
      okButtonTitle: t('screenshot.share_action'),
      cancelButtonTitle: t('screenshot.cancel_action'),
    });

    if (value) {
      await Share.share({
        title: t('screenshot.title'),
        text: t('screenshot.text'),
        url: pictureUri,
        dialogTitle: '',
      });
    }
  } catch (e: any) {
    if (e.message !== 'Share canceled') {
      alert(e.message);
    }
  } finally {
    await hideLoader();
  }
};

return (_ctx: any,_cache: any) => {
  return (_unref(computeWizardStore).isValid)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(IonCard), { class: "calculation-result__card calculation-result__card--main" }, {
          default: _withCtx(() => [
            (isMobile.value)
              ? (_openBlock(), _createBlock(BaseButton, {
                  key: 0,
                  class: "calculation-result__save-screen-shot-button",
                  fill: "clear",
                  onClick: onScreenShotButtonClick
                }, {
                  default: _withCtx(() => [
                    _createVNode(BaseIcon, {
                      icon: _unref(Icons).Save
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(IonText), { class: "calculation-result__main-result" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(computeWizardStore).computedValues.finalValue), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonText), { class: "calculation-result__result-unit" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(computeWizardStore).computedValues.unit), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonText), { class: "calculation-result__washer-hardness" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(washerHardnessLabel.value), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonCard), { class: "calculation-result__card calculation-result__card--secondary" }, {
          default: _withCtx(() => [
            _createElementVNode("table", _hoisted_2, [
              _createElementVNode("thead", _hoisted_3, [
                _createElementVNode("tr", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("th", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_ctx.$t('result.table.head.torque')), 1),
                    _hoisted_7,
                    _createTextVNode(_toDisplayString(_unref(computeWizardStore).computedValues.unit), 1)
                  ]),
                  _createElementVNode("th", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.$t('result.table.head.tension')), 1),
                    _hoisted_9,
                    _createTextVNode("N")
                  ]),
                  _createElementVNode("th", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_ctx.$t('result.table.head.constraint')), 1),
                    _hoisted_11,
                    _createTextVNode("N/mm"),
                    _hoisted_12
                  ])
                ])
              ]),
              _createElementVNode("tbody", _hoisted_13, [
                _createElementVNode("tr", _hoisted_14, [
                  _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('result.table.body.min')), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(computeWizardStore).computedValues.min.torque), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(computeWizardStore).computedValues.min.tension), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(computeWizardStore).computedValues.min.constraint), 1)
                ]),
                _createElementVNode("tr", _hoisted_19, [
                  _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('result.table.body.moy')), 1),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(computeWizardStore).computedValues.moy.torque), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(computeWizardStore).computedValues.moy.tension), 1),
                  _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(computeWizardStore).computedValues.moy.constraint), 1)
                ]),
                _createElementVNode("tr", _hoisted_24, [
                  _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.$t('result.table.body.max')), 1),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(_unref(computeWizardStore).computedValues.max.torque), 1),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(_unref(computeWizardStore).computedValues.max.tension), 1),
                  _createElementVNode("td", _hoisted_28, _toDisplayString(_unref(computeWizardStore).computedValues.max.constraint), 1)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})